import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
//import DialogTitle from '@material-ui/core/DialogTitle';
import Input from '@material-ui/core/Input';
import { Grid } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import { styles } from './styles';
import Apis from '../../../../../utils/Apis'
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

function PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
}

const DialogTitle = withStyles(styles)(props => {
        const { children, classes, onClose } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                            <IconButton  aria-label="Close" className={classes.closeButton} onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                           ) : null}
            </MuiDialogTitle>
        );
});

class Edit extends Component {

    state = {
        id: this.props.id,
        name: this.props.name,
        working_hour: this.props.working_hour,
        pay_hour: this.props.pay_hour,
        new_working_hour: this.props.working_hour,
        new_pay_hour: this.props.pay_hour,
        worker_id: this.props.worker_id,
        site_id: this.props.site_id,
        site_name: this.props.site_name,
        type_id: this.props.type_id,
        type_name: this.props.type_name,
        requesting: false,

        site_index_selected: 0,
        site_names: [],
        site_ids: [],

        type_index_selected: 0,
        type_names: [],
        type_ids: []
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.registered === 1) {
            this.props.onClose();
            return;
        }
        if (nextProps.registered === -1 && nextProps.error.body !== undefined) {
            this.props.onAlertMessage("error", nextProps.error.body.message);
            return;
        }
    }
    componentDidMount() {
        var temp_site_ids = [];
        var temp_site_names = [];
        var temp_type_ids = [];
        var temp_type_names = [];
        const { sites, types, site_id, type_id } = this.props;
        sites.map((item) => {
            temp_site_ids.push(item._id);
            temp_site_names.push(item.name);
        });
        types.map((item) => {
            temp_type_ids.push(item._id);
            temp_type_names.push(item.name);
        });

        var site_index = temp_site_ids.findIndex(x => x==site_id);
        var type_index = temp_type_ids.findIndex(x => x==type_id);
        this.setState({
            site_ids: temp_site_ids,
            site_names: temp_site_names,
            type_ids: temp_type_ids,
            type_names: temp_type_names,
            site_index_selected: site_index,
            type_index_selected: type_index
        });
    }

    onClose = () => {
        this.props.onClose();
    }
    handleChange = name => event => {


        let mins = Math.floor(event.target.value);
        var h = Math.floor(mins / 60);
        var m = Math.floor(mins % 60);

        var h_pay = h;
        var m_pay = m;

        if (m >= 0 && m < 15) {
            m_pay = 15
        } else if (m >= 15 && m < 30) {
            m_pay = 30
        } else if (m >= 30 && m < 45) {
            m_pay = 45
        } else {
            m_pay = 0
            h_pay = h_pay + 1
        }
        var total_m_pay = h_pay * 60 + m_pay;
        this.setState({
            [name]: event.target.value,
            new_pay_hour: total_m_pay
        });

    };

    handleChangeSelect = event => {
        const { site_ids, site_names, type_ids, type_names } = this.state;
        let site_id = site_ids[event.target.value];
        let site_name = site_names[event.target.value];
        let type_id = type_ids[event.target.value];
        let type_name = type_names[event.target.value];
        this.setState({
            [event.target.name]: event.target.value,
            site_id: site_id,
            site_name: site_name,
            type_id: type_id,
            type_name: type_name
         });
    };
    onUpdate = () => {
        const { requesting } = this.state;
        const { id, name, new_working_hour, new_pay_hour, working_hour, pay_hour, worker_id, site_id, site_name, type_id, type_name } = this.state;
        if (requesting) {
            return;
        }

        if (new_working_hour === '') {
            this.props.onAlertMessage("error", "Please input working hour!");
            return;
        }
        if (new_pay_hour === '') {
            this.props.onAlertMessage("error", "Please input pay hour!");
            return;
        }
        
        this.setState({ requesting: true });
        Apis.updateHistory({ 'history_id': id, 'worker_id': worker_id, 'site_id': site_id, 'site_name': site_name, 'type_id': type_id, 'type_name': type_name, 'add_working_hours': new_working_hour, 'add_pay_hours': new_pay_hour })
            .then(res => {

                this.setState({ requesting: false });
                let data = res.data;
                let status = data.status;
                if (status === 'success') {
                    this.props.onAlertMessage("success", "History was successfully updated.");
                    this.props.onDoneEdit();
                    return
                } else {
                    this.props.onAlertMessage("error", data.message);
                }

            })
            .catch(err => {
                this.setState({ requesting: false });
                this.props.onAlertMessage("error", err.response.data.message);
            })
    }

    handleChangeSite = () => event => {
        this.setState({ site: event.target.value });
    };
    render() {
        const { classes } = this.props;
        const { open } = this.props;
        const { id, name, new_working_hour, new_pay_hour, requesting, site_names, site_index_selected, type_names, type_index_selected } = this.state;
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.onClose}
                    PaperComponent={PaperComponent}
                    aria-labelledby="signup-dialog-title"
                    aria-describedby="signup-dialog-description">
                    <DialogTitle style={{ cursor: 'move' }} id="simple-dialog-title" onClose={this.onClose}/>
                    <DialogContent>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems='center'
                            className={classes.main_container}>

                            <Grid container
                                direction="column">
                                <FormControl
                                    className={classes.formControl}>
                                    <InputLabel shrink htmlFor="ibName" className={classes.inputlabel}>
                                        Name
                                    </InputLabel>
                                    <OutlinedInput
                                        id="ibName"
                                        placeholder="Worker Name"
                                        classes={{
                                            root: classes.inputbaseRoot,
                                            input: classes.inputbaseInput,
                                        }}
                                        value={name}
                                        onChange={this.handleChange('name')}
                                        fullWidth
                                        disabled
                                    />
                                </FormControl>
                                <FormControl
                                    className={classes.formControl}>
                                    <InputLabel shrink htmlFor="ibWorkingHour" className={classes.inputlabel}>
                                        Working Hour(min)
                                    </InputLabel>
                                    <OutlinedInput
                                        id="ibWorkingHour"
                                        placeholder="Number"
                                        classes={{
                                            root: classes.inputbaseRoot,
                                            input: classes.inputbaseInput,
                                        }}
                                        value={new_working_hour}
                                        onChange={this.handleChange('new_working_hour')}
                                        fullWidth
                                    />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                    <InputLabel shrink htmlFor="site" className={classes.inputlabel}>Site</InputLabel>
                                    <Select
                                        value={site_index_selected}
                                        onChange={this.handleChangeSelect}
                                        inputProps={{
                                            name: 'site_index_selected',
                                            id: 'site',
                                        }}
                                        className={classes.inputlabel}
                                    >
                                        {site_names.map((item, index) => {
                                            return (
                                                <MenuItem value={index} className={classes.inputlabel}>{item}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                    <InputLabel shrink htmlFor="type" className={classes.inputlabel}>Type</InputLabel>
                                    <Select
                                        value={type_index_selected}
                                        onChange={this.handleChangeSelect}
                                        inputProps={{
                                            name: 'type_index_selected',
                                            id: 'type',
                                        }}
                                        className={classes.inputlabel}
                                    >
                                        {type_names.map((item, index) => {
                                            return (
                                                <MenuItem value={index} className={classes.inputlabel}>{item}</MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <div className={classes.wrapper}>
                            <Grid item container direction="column" justify="center" alignItems="stretch">
                                <Button color="primary" variant="contained" className={classes.btnNewAccount}
                                    onClick={this.onUpdate}>
                                    Update
                                </Button>
                            </Grid>
                            {requesting && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

// const RegisterlWrapped = withStyles(styles)(Register);


export default withStyles(styles)(Edit);
